import {
  PhaseStructureTypeEnum,
  SubdivisionAuditInterface,
} from '@vatos-pas/common';
import {
  auditColumnsToCsvColumns,
  CHANGED_BY_CSV_COLUMN,
  CostStructureHistoryRow,
  CsvColumn,
  TIMESTAMP_CSV_COLUMN,
  WithDecimalCells,
} from 'utils/costStructureHistoryCsv';
import {
  formatProductionPricing,
  getCostColumnsForWorkflow,
  SubdivisionAuditCostField,
  SUBDIVISION_AUDIT_ALLOW_PAYOUT_EDITING_COLUMN,
  SUBDIVISION_AUDIT_SPECIAL_JOBS_COLUMN,
} from './auditColumns';

type SubdivisionAuditDecimalField =
  | SubdivisionAuditCostField
  | 'specialJobsPercentage';

export type SubdivisionAuditCsvRow = WithDecimalCells<
  Pick<
    SubdivisionAuditInterface,
    | SubdivisionAuditDecimalField
    | 'overrideType'
    | 'overrideRegionCostPerBoard'
    | 'allowPayoutAmountEditing'
  >,
  SubdivisionAuditDecimalField
> &
  CostStructureHistoryRow;

/** Same order and labels as the on-screen table. */
export const getSubdivisionAuditCsvColumns = (
  phaseStructureType: PhaseStructureTypeEnum,
): CsvColumn<SubdivisionAuditCsvRow>[] => [
  CHANGED_BY_CSV_COLUMN,
  {
    label: 'Production Pricing',
    value: record => formatProductionPricing(record.overrideType),
  },
  {
    label: 'Override',
    value: record => (record.overrideRegionCostPerBoard ? 'Yes' : 'No'),
  },
  TIMESTAMP_CSV_COLUMN,
  ...auditColumnsToCsvColumns<SubdivisionAuditCsvRow>([
    ...getCostColumnsForWorkflow(phaseStructureType),
    SUBDIVISION_AUDIT_SPECIAL_JOBS_COLUMN,
    SUBDIVISION_AUDIT_ALLOW_PAYOUT_EDITING_COLUMN,
  ]),
];
